(function(angular){
    'use strict';

    angular.module('aprima-provider-api').factory('ImoDiagnosisRepository', [
        '$q',
        'AprimaAnalytics', 
        'AprimaRestangular', 
        'ImoPatient',
        ImoDiagnosisRepository
    ]);

    function ImoDiagnosisRepository(
        $q, 
        AprimaAnalytics, 
        AprimaRestangular, 
        ImoPatient
    ) {
        var routePrefix = 'imo-problem';

        var service = {
            term: _.partial(term, null),
            terms: _.partial(terms, null),
            detail: _.partial(detail, null),
            details: _.partial(details, null),
            count: _.partial(count, null),
            abortable: abortable,
        };
        
        return service;

        function abortable(promisesToAbort) {
            return {
                term: _.partial(term, promisesToAbort),
                terms: _.partial(terms, promisesToAbort),
                detail: _.partial(detail, promisesToAbort),
                details: _.partial(details, promisesToAbort),
                count: _.partial(count, promisesToAbort),
            };
        }
        
        function term(promisesToAbort, paramsObj) {
            var result = get(promisesToAbort, 'terms', paramsObj, regularGet);
            return result;
        }

        function terms(promisesToAbort, paramsObj, patient) {
            var params = createPatientParams(paramsObj, patient);
            
            var result = get(promisesToAbort, 'terms', params, customGet);
            return result;
        }

        function detail(promisesToAbort, paramsObj) {
            var result = get(promisesToAbort, 'detail-terms', paramsObj, regularGet);
            return result;
        }
        
        function details(promisesToAbort, paramsObj) {
            var result = get(promisesToAbort, 'detail-terms', paramsObj, customGet);
            return result;
        }
        
        function count(promisesToAbort, paramsObj, patient) {
            var params = createPatientParams(paramsObj, patient);
            params.CountOnly = true;
            
            var result = get(promisesToAbort, 'terms', params, customGet);
            return result;
        }

        function createPatientParams(paramsObj, patient) {
            paramsObj = paramsObj || {};
            if(patient instanceof ImoPatient) {
                if(patient.hasAge) {
                    paramsObj.PatientAge = patient.standardizedAge;
                }
                if(patient.hasGender) {
                    paramsObj.PatientGender = patient.standardizedGender;
                }
            }
            return paramsObj;
        }

        function get(promisesToAbort, route, params, getFn) {
            var restElement = AprimaRestangular.get().all(routePrefix).all(route);
            if(promisesToAbort) {
                restElement = restElement.abortable(promisesToAbort);
            }

            return getFn(restElement, params).then(function(data) {
                if(_.isNil(data)) {
                    return $q.reject('IMO ' + api + ' request failed for params: ' + JSON.stringify(params));
                }

                return data;
            });
        }

        function regularGet(element, params) {
            return element.get(params);
        }

        function customGet(element, params) {
            return element.customGET('', params);
        }
    }
})(window.angular);
